import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hdz6pz52m7: FaireBrandEntity = {
  token: "b_hdz6pz52m7",
  type: "brand",
  name: "THYKK",
  avatarUrl:
    "https://cdn.faire.com/fastly/a979962123ff67f0beb79c93a4130bee5a96e59db2ec833cdd41c98ad64890d0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/694d7967926f72d670e22192f8b5f6609f114dfd8d72882bba350c8ad89300b0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a979962123ff67f0beb79c93a4130bee5a96e59db2ec833cdd41c98ad64890d0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/694d7967926f72d670e22192f8b5f6609f114dfd8d72882bba350c8ad89300b0.png",
  location: "Toronto, ON, CAN",
  minimumOrderDollars: 150,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "THYKK was created by two sisters in 2021 with the intention of empowering women through gorgeous hair. THYKK is a hair extension brand rooted in the belief that when you feel your best you embody the best version of yourself.\nTHYKK offers Clip In, Fusion, Halo, Tape In and Weft extensions of double-drawn, 100% Remy hair in 29 colours and growing.\nCo-founders and sisters, Ingunn and Signy were both born and raised in Iceland and currently reside in Canada. They chose the name THYKK because of its positivity and the thick quality of THYKK hair. THYKK is pronounced and has the same meaning in both English and Icelandic, their native tongue.\nIngunn is an extension specialist, trained by various brands in numerous cutting, colouring and styling methods. She's been in the hair industry specializing in hair extensions since 2008.\nSigny is a business boss working in the health and wellness industry since 2015. She's passionate about community, e-commerce and brand development.\nIt is Ingunn and Signy's deep desire that THYKK empowers you to do what you desire. Dream big, besties!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:02.549Z",
    importedBy: "entity-db-cli",
  },
};
